import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CredentialsService } from './credentials.service';

/**
 * Para páginas personales (p. ej. Sesiones activas): basta con tener sesión, sin
 * alta de módulo ni acceso por empresa como pide `authGuard`. El backend sigue
 * validando el permiso de cada endpoint.
 *
 * Se revisa que existan credenciales y no que el access token esté vigente: si ya
 * venció, el interceptor lo renueva con el refresh token en la primera petición.
 */
export const loggedInGuard: CanActivateFn = () => {
    const credentials = inject(CredentialsService).credentials;
    const router = inject(Router);
    if (!credentials?.accessToken) {
        return router.createUrlTree(['/auth/login']);
    }
    // Quien sigue con la contraseña inicial (el RFC) primero la cambia: no debe poder
    // crear una llave de acceso ni gestionar sesiones antes.
    // El DTO generado lo tipa como string; el backend manda boolean.
    if (String(credentials.isDefaultPassword) === 'true') {
        return router.createUrlTree(['/auth/password-update']);
    }
    return true;
};
